export const CATEGORIES = [
  { id: "all", label: "All Listings", icon: "Sparkles" },
  { id: "dogs", label: "Dogs & Puppies", icon: "Dog" },
  { id: "cats", label: "Cats & Kittens", icon: "Cat" },
  { id: "birds", label: "Birds", icon: "Bird" },
  { id: "reptiles", label: "Reptiles", icon: "Turtle" },
  { id: "aquatics", label: "Aquatics", icon: "Fish" },
  { id: "small-pets", label: "Small Pets", icon: "Rabbit" },
  { id: "supplies-services", label: "Supplies & Services", icon: "ShoppingBag" },
  { id: "livestock", label: "Livestock", icon: "Tractor" },
  { id: "rescue", label: "Rescue", icon: "HeartHandshake" },
  { id: "lost-found", label: "Lost & Found", icon: "Megaphone" },
  { id: "iso", label: "Wanted (ISO)", icon: "Search" },
];

export const isIso = (l) => l?.category === "iso";

export const CATEGORY_LABEL = CATEGORIES.reduce((a, c) => ({ ...a, [c.id]: c.label }), {});

export const PROVINCES = [
  { code: "all", name: "All of Canada" },
  { code: "ON", name: "Ontario" },
  { code: "BC", name: "British Columbia" },
  { code: "AB", name: "Alberta" },
  { code: "QC", name: "Quebec" },
  { code: "MB", name: "Manitoba" },
  { code: "SK", name: "Saskatchewan" },
  { code: "NS", name: "Nova Scotia" },
  { code: "NB", name: "New Brunswick" },
  { code: "NL", name: "Newfoundland & Labrador" },
  { code: "PE", name: "Prince Edward Island" },
  { code: "YT", name: "Yukon" },
  { code: "NT", name: "Northwest Territories" },
  { code: "NU", name: "Nunavut" },
];

export const PROVINCE_NAME = PROVINCES.reduce((a, p) => ({ ...a, [p.code]: p.name }), {});

export const priceLabel = (l) => {
  if (l.price_type === "free") return "Free";
  if (l.price_type === "contact" || l.price == null) return "Contact for price";
  return `$${Number(l.price).toLocaleString("en-CA")}`;
};

// Approximate map coordinates — listings only store city + province text
export const PROV_CENTER = {
  all: [56.1, -96.8], ON: [49.5, -85.0], BC: [53.7, -125.0], AB: [53.9, -116.6],
  QC: [52.0, -72.0], MB: [53.7, -98.8], SK: [54.0, -106.0], NS: [45.0, -63.0],
  NB: [46.5, -66.0], NL: [53.1, -57.7], PE: [46.4, -63.2],
};

export const CITY_COORDS = {
  "toronto": [43.6532, -79.3832], "ottawa": [45.4215, -75.6972], "mississauga": [43.589, -79.6441],
  "brampton": [43.7315, -79.7624], "hamilton": [43.2557, -79.8711], "london": [42.9849, -81.2453],
  "markham": [43.8561, -79.337], "vaughan": [43.8361, -79.4983], "kitchener": [43.4516, -80.4925],
  "windsor": [42.3149, -83.0364], "kingston": [44.2312, -76.486], "barrie": [44.3894, -79.6903],
  "vancouver": [49.2827, -123.1207], "surrey": [49.1913, -122.849], "burnaby": [49.2488, -122.9805],
  "victoria": [48.4284, -123.3656], "kelowna": [49.888, -119.496], "richmond": [49.1666, -123.1336],
  "abbotsford": [49.0504, -122.3045], "nanaimo": [49.1659, -123.9401],
  "calgary": [51.0447, -114.0719], "edmonton": [53.5461, -113.4938], "red deer": [52.2681, -113.8112],
  "lethbridge": [49.6956, -112.8451], "montreal": [45.5019, -73.5674], "quebec city": [46.8139, -71.208],
  "québec": [46.8139, -71.208], "laval": [45.6066, -73.7124], "gatineau": [45.4765, -75.7013],
  "sherbrooke": [45.4042, -71.8929], "winnipeg": [49.8951, -97.1384], "brandon": [49.8485, -99.95],
  "saskatoon": [52.1332, -106.67], "regina": [50.4452, -104.6189], "halifax": [44.6488, -63.5752],
  "sydney": [46.1368, -60.1942], "dartmouth": [44.6658, -63.5669], "fredericton": [45.9636, -66.6431],
  "moncton": [46.0878, -64.7782], "saint john": [45.2733, -66.0633], "st. john's": [47.5615, -52.7126],
  "st johns": [47.5615, -52.7126], "charlottetown": [46.2382, -63.1311], "summerside": [46.3959, -63.7873],
};

// Deterministic tiny jitter so multiple listings in the same city don't stack exactly
const _hash = (s) => { let h = 0; for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0; return h; };
export const geocodeListing = (l) => {
  const c = (l.city || "").trim().toLowerCase();
  const base = CITY_COORDS[c] || PROV_CENTER[l.province] || PROV_CENTER.all;
  const h = _hash(l.id || l.title || "x");
  const dLat = ((h % 100) / 100 - 0.5) * 0.08;
  const dLng = (((h >> 8) % 100) / 100 - 0.5) * 0.08;
  return [base[0] + dLat, base[1] + dLng];
};
